import React, { Component } from 'react';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Switch from '../../Part_Sample/Switch';
import Editbox from '../../Part_Sample/Editbox';
import { isEmpty } from '../../Common/Common';

import Management_Point_Selection_Cell from '../../Part_Sample/Management_Point_Selection_Cell';

export default class Add_Edit_Changeover extends Component {
	constructor(props) {
		super(props);

		window.app.hideLoading();
		this.lastClickTime = false;

		let is_enabled = false;
		let name = '';
		let guard_timer = 15; // 15min or more
		let mode = 'fix';
		let points = [];
		let target = ''; // Used when mode = 'fix'
		let heat_override = false;
		let diff = 0.75;
		let hodiff = 2;
		let weight = {};

		if (this.props.param.grp_id != null) {
			let changeover_info = this.props.param.changeover_groups[this.props.param.grp_id];
			is_enabled = changeover_info.enable;
			name = changeover_info.name;
			mode = changeover_info.mode;
			guard_timer = changeover_info.guard_timer;

			if(!isEmpty(changeover_info.points)) {
				points = [...changeover_info.points];

				points.forEach((pid, index) => {
					if(!window.app.state.point_list.hasOwnProperty(pid)) {
						points.splice(index, 1);
					}
				});
			}

			target = changeover_info.target;
			heat_override = changeover_info.heat_override;
			weight = changeover_info.weight;
		}

		this.state = {
			is_enabled: is_enabled,
			name: name,
			guard_timer: guard_timer,
			points: points,
			mode: mode,
			target: target,
			heat_override: heat_override,
			diff: diff,
			hodiff: hodiff,
			weight: weight,
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		if (!this.preventMultipleTaps()) return;

		this.props.content_handler('Changeover', this.props.param);
	}

	handleToggleEnable = () => {
		this.setState({ is_enabled: !this.state.is_enabled })
	}

	handleChangeName = (val) => {
		this.setState({ name: val })
	}

	handleChangeMode = (val) => {
		let target = this.state.target;
		let weight = {};

		if (val == 'fix' && target == '' && this.state.points.length > 0) {
			target = this.state.points[0];
		}

		if(val == 'vote') {
			for (var pid in this.state.points) {
				weight[this.state.points[pid]] = 0;
			}
		}

		this.setState({
			mode: val,
			target: target,
			weight: weight
		});
	}

	handleChangeGuardTimer = (val) => {
		this.setState({ guard_timer: val })
	}

	handleSelectPoints = (point_id) => {
		let points = this.state.points;
		let weight = this.state.weight;
		let targetTemp = this.state.target;

		if (points.includes(point_id)) {
			points.splice(points.indexOf(point_id), 1);
			if (weight.hasOwnProperty(point_id)) delete weight[point_id];

			if(targetTemp == point_id) targetTemp = '';
		} else {
			points.push(point_id);
			weight[point_id] = 0;

			if(targetTemp == '') targetTemp = point_id;
		}

		this.setState({
			points: points,
			weight: weight,
			target: targetTemp
		})
	}

	handleChangeTarget = (val) => {
		this.setState({ target: val })
	}

	handleToggleHeatOverride = () => {
		this.setState({ heat_override: !this.state.heat_override })
	}

	handleChangeWeight = (point_id, val) => {
		let weight = this.state.weight;
		weight[point_id] = val;

		this.setState({ weight: weight });
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;

		let tempName = this.state.name.split(/\s/).join('');  //check for names that are just spaces.

		if (tempName == '') {
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		if (this.state.points.length == 0 || (this.state.mode == 'fix' && this.state.target == '')) {
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('sel_device'), 3000);
			return;
		}

		window.app.showLoading();

		let changeover_info = {};
		changeover_info.enable = this.state.is_enabled;
		changeover_info.name = this.state.name;
		changeover_info.guard_timer = parseInt(this.state.guard_timer);
		changeover_info.points = this.state.points;
		changeover_info.mode = this.state.mode;
		changeover_info.heat_override = this.state.heat_override;
		changeover_info.diff = this.state.diff;
		changeover_info.hodiff = this.state.hodiff;

		if(this.state.mode == 'fix') {
			changeover_info.target = this.state.target;
			changeover_info.weight = {};
		} else if(this.state.mode == 'vote') {
			changeover_info.target = '';

			let tWeight = this.state.weight;

			for (let pid in tWeight) {
				try{
					tWeight[pid] = parseInt(tWeight[pid]);
				}catch(e){
					//couldn't parse
				}
			}

			changeover_info.weight = tWeight;
		}

		if (this.props.param.grp_id == null) {
			this.props.receiver.addChangeover(changeover_info);
		} else {
			let edit_changeover = {};
			edit_changeover[this.props.param.grp_id] = changeover_info;
			this.props.receiver.modifyChangeover(edit_changeover);
		}
	}

	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;
		
		window.app.showLoading();
		this.props.receiver.deleteChangeover(this.props.param.grp_id);
	}

	rcvAddChangeover = (response) => {
		if (response.result != 'NG') {
			this.props.receiver.getChangeOverGroups();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyChangeover = (response) => {
		if (response.result == 'OK') {
			this.props.receiver.getChangeOverGroups();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteChangeover = (response) => {
		if (response.result == 'OK') {
			this.props.receiver.getChangeOverGroups();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let content_line_style = {
			width: this.props.width - 80,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			padding: 15,
			verticalAlign: 'top',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		const range = [];
		range.push(<option value={'fix'}>{this.props.receiver.getString('fix')}</option>);
		range.push(<option value={'vote'}>{this.props.receiver.getString('vote')}</option>);

		const guard_timer_range = [];
		for (let i = 15; i < 60; i += 5) {
			guard_timer_range.push(<option value={i}>{i}</option>);
		}

		const target_range = [];
		target_range.push(<option value={""}>{this.props.receiver.getString('sel_device')}</option>);
		for (let point_id of this.state.points) {
			if(window.app.state.point_list.hasOwnProperty(point_id)) {
				target_range.push(<option value={point_id}>{window.app.state.point_list[point_id].name}</option>);
			}
		}

		const weight_range = [];
		for (let weight = 0; weight <= 3; weight++) {
			weight_range.push(<option value={weight}>{weight}</option>);
		}

		let already_selected_points = [];
		for (let grp_id in this.props.param.changeover_groups) {
			if (grp_id != this.props.param.grp_id) {
				let group = this.props.param.changeover_groups[grp_id];
				already_selected_points = already_selected_points.concat(group.points);
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('change_over')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div>
						<div style={{ display: 'inline-block', width: this.props.width - 100, marginLeft: 10 }}>
							<Editbox id='name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeName(event.target.value)} value={this.state.name} />
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
							<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
						</div>
					</div>

					<div style={content_line_style}>
						<div style={{ display: 'inline-block', width: this.props.width - 180 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('mode')}</span>
						</div>
						<div style={{ display: 'inline-block', width: 100 }}>
							<Select
								options={range}
								value={this.state.mode}
								onSelect={this.handleChangeMode}
							/>
						</div>
					</div>

					<div style={content_line_style}>
						<div style={{ display: 'inline-block', width: this.props.width - 180 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('guard_timer')}</span>
						</div>
						<div style={{ display: 'inline-block', width: 100 }}>
							<Select
								options={guard_timer_range}
								value={this.state.guard_timer}
								onSelect={this.handleChangeGuardTimer}
							/>
						</div>
					</div>

					<div style={{ ...content_line_style, display: this.state.mode == 'fix' ? 'none' : 'block' }}>
						<div style={{ display: 'inline-block', width: this.props.width - 130 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('heat_override')}</span>
						</div>
						<div style={{ display: 'inline-block' }}>
							<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.heat_override} handleToggleSwitch={this.handleToggleHeatOverride} />
						</div>
					</div>

					<div style={{ ...content_line_style, display: this.state.mode == 'fix' ? 'block' : 'none', marginTop: 10 }}>
						<div style={{ display: 'inline-block', width: this.props.width - 260 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('target')}</span>
						</div>
						<div style={{ display: 'inline-block', width: 180 }}>
							<Select
								options={target_range}
								value={this.state.target}
								onSelect={this.handleChangeTarget}
							/>
						</div>
					</div>

					<div style={{ height: this.props.height - 410, marginTop: 10, }}>
						<div style={{ textAlign: 'center' }}>
							<span className='title' style={{ fontSize: 18 }}>{this.props.receiver.getString('device')}</span>
						</div>
						<div style={{ height: this.props.height - 440, overflow: 'auto' }}>
							{Object.keys(window.app.state.point_list).map((point_id) => {
								let point_info = window.app.state.point_list[point_id];
								if (!isEmpty(point_info)) {
									if (point_info.type == 'Ac') {
										return (
											<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
												<Management_Point_Selection_Cell
													style={{ display: 'block' }}
													id={point_id}
													height={this.props.height}
													width={this.props.width}
													key={point_id}
													handleSetToggle={this.handleSelectPoints}
													point_info={point_info}
													is_selected={this.state.points.includes(point_id)}
													is_disabled={already_selected_points.includes(point_id)}
												>
													<div style={{ display: this.state.points.includes(point_id) && this.state.mode == 'vote' ? 'block' : 'none', textAlign: 'center' }}>
														<div style={{ display: 'inline-block' }}>
															<span>{this.props.receiver.getString('weight')}</span>
														</div>
														<div style={{ display: this.state.points.length > 0 ? 'inline-block' : 'none', marginLeft: 10 }}>
															<Select
																options={weight_range}
																value={this.state.weight[point_id] == null ? 0 : this.state.weight[point_id]}
																onSelect={(val) => this.handleChangeWeight(point_id, val)}
																disabled={already_selected_points.includes(point_id)}
															/>
														</div>
													</div>
												</Management_Point_Selection_Cell>
											</div>
										)
									} else {
										return null;
									}
								} else {
									return null;
								}
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}